var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 27,
    rx: 10,
    fill: "#C1DEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 13.3333H16.3333V8.5C16.3333 8.22386 16.1095 8 15.8333 8C15.5572 8 15.3333 8.22386 15.3333 8.5V13.3333H10.5C10.2239 13.3333 10 13.5572 10 13.8333C10 14.1095 10.2239 14.3333 10.5 14.3333H15.3333V19.1667C15.3333 19.4428 15.5572 19.6667 15.8333 19.6667C16.1095 19.6667 16.3333 19.4428 16.3333 19.1667V14.3333H21.1667C21.4428 14.3333 21.6667 14.1095 21.6667 13.8333C21.6667 13.5572 21.4428 13.3333 21.1667 13.3333Z",
    fill: "#404A51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.5ad6438e6718892ae3cc3076dda0ecdf.svg";
export { ForwardRef as ReactComponent };